import { DISCONTINUED_LINE_CHECK_SUCCESS } from '@/constants/orderConstants'

// Rows flagged by the last discontinued line check, keyed by line_item_id. Each check replaces
// the map, so a line fixed since the previous approve attempt drops its tag.
export const discontinuedLineCheckReducer = (state = { byLineItemId: {} }, action) => {
  switch (action.type) {
    case DISCONTINUED_LINE_CHECK_SUCCESS:
      return { byLineItemId: action.payload || {} }
    default:
      return state
  }
}
